export const required = value =>
  value ? undefined : "Das Feld ist erforderlich.";

export const maxLength = max => value =>
  value && value.length > max
    ? `Das Feld muss eine Zeichenfolge mit einer maximalen Länge von ${max} sein.`
    : undefined;

export const maxLength100 = maxLength(100);
export const maxLength500 = maxLength(500);

export const minLength = min => value =>
  value && value.length < min
    ? `Das Feld muss eine Zeichenfolge mit einer minimalen Länge von ${min} sein.`
    : undefined;

export const minLength2 = minLength(2);

export const number = value =>
  value && isNaN(Number(value)) ? "Muss eine Nummer sein" : undefined;

export const minValue = min => value =>
  value && value < min ? `Muss mindestens ${min} sein` : undefined;

export const minValue18 = minValue(18);

export const email = value =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
    ? "Ungültige E-Mail-Adresse"
    : undefined;

export const telefon = value =>
  value && !/^\d{8,20}$/i.test(value) ? "Ungültige Telefonnummer" : undefined;



// WEBPACK FOOTER //
// ./src/validation.js